var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84999 17.15L3.64999 15.4L4.69999 14.35L7.19999 14.7L11.1 10.8L3.29999 6.55L4.69999 5.15L14.25 7.6L18.175 3.725C18.4583 3.44167 18.8127 3.3 19.238 3.3C19.6633 3.3 20.0173 3.44167 20.3 3.725C20.5833 4.00834 20.725 4.36267 20.725 4.788C20.725 5.21334 20.5833 5.56734 20.3 5.85L16.4 9.75L18.85 19.3L17.45 20.7L13.2 12.9L9.29999 16.8L9.64999 19.3L8.59999 20.35L6.84999 17.15Z",
    fill: "#9DAAF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelIcon);
export default __webpack_public_path__ + "static/media/travel-icon.e6e193acdaa4b27b484ede9f83c51d5b.svg";
export { ForwardRef as ReactComponent };